import React from 'react';
import hark from  'hark';
import util from '../../lib/util';

class VideoVolume extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      remoteUser: this.props.remoteUser,
      speechEvent: null,
      volume: 0
    };
  }

  componentDidMount() {
    
    const speechEvent = hark(this.props.remoteUser.stream, {});
    // dB = 0 ~ -100(mute)
    const handleVolumeChange = util.throttle(100, (volumeDecibel) => {
      // 0 ~ -100 => 5 ~ 0
      let volume = Math.floor(volumeDecibel / 20) + 5;
      if (volume < 0) {
        volume = 0;
      }
      this.setState({ volume });
    })
    speechEvent.on('volume_change', handleVolumeChange);
    this.setState({ speechEvent })
  }

  componentWillUnmount() {
    if(this.state.speechEvent){
      this.state.speechEvent.stop();
    }
    
  }

  render() {
    const list = []; 
    for (let i = 0; i < 5 - this.state.volume; i++) {
        list.push(<span key={i} className="volume-indicator__item volumeInde"/>)
      }
    for (let i = 0; i < this.state.volume; i++) {
      list.push(<span key={i+"_active"} className="volume-indicator__item --active volumeInde"/>)
    }
    return  (
      <div className="volume-indicator" style={{ ...this.props.volumePositionStyle }}>
        {list}
      </div>
    );
  }
}

export { VideoVolume };



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/VideoVolume.js